import { z } from "zod"

export const updateAnalysisSchema = z.object({
  question: z
    .string({
      required_error: "La pregunta es requerida",
    })
    .min(1, { message: "La pregunta es requerida" }),
  answer: z
    .string({
      required_error: "La respuesta es requerida",
    })
    .min(1, { message: "La respuesta es requerida" }),
})

export type UpdateAnalysisFormValues = z.infer<typeof updateAnalysisSchema>
